import React from 'react';
import T from 'prop-types';
import { Stack, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { stringDateToDate, formatDate } from '../../utils/utils';

function FilterForm({ initialDate, setInitalDate, endDate, setEndDate }: { initialDate: string, setInitalDate: any, endDate?: string, setEndDate: any }) {
  const initialDateDate = stringDateToDate(initialDate);
  return (
    <Stack
      component="div"
      direction='row'
      sx={{
        margin: '0 auto'
      }}
    >
      <DatePicker
        label="Start Date"
        value={initialDateDate}
        onChange={e => {
          if(e){
            setInitalDate(formatDate(e));
          }
        }}
        renderInput={(params) => <TextField {...params} />}
      />
      <DatePicker
        label="End Date"
        value={endDate}
        onChange={e => {
          if(e){
            setEndDate(formatDate(e));
          }
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </Stack>
  );
};

FilterForm.propTypes = {
  initialDate: T.string,
  setEndDate: T.func,
  setInitalDate: T.func
};

export default FilterForm;